angular.module("ugcRouterModule", [
        'headerModule',
        'headerLoginModule',
        'leftNavModule',
        'mainModule',
        'loginModule',
        'backstageHeaderModule',
    	'webHeaderModule'
    ])
    .config(["$stateProvider", "$urlRouterProvider", function($stateProvider, $urlRouterProvider) {
        $stateProvider.state("index", {
            url: "/index",
            views: {
                "": {
                    template: '<div class="view_head" ui-view="header"></div>' +
                        '<div class="view_body">' +
                        '<div class="view_sidebar leftGreen" ui-view="leftNav"></div>' +
                        '<div class="view_content view_content_full mainGreen" ui-view="main"></div>' +
                        '</div>'
                },
                "header@index": {
                    templateUrl: 'header/header_tpl.html',
                    controller: 'headerCtrl'
                },
                "leftNav@index": {
                    templateUrl: 'leftNav/leftNav_tpl.html',
                    controller: 'leftNavCtrl'
                }
            }
        }).state("login", {
            url: "/login?orgurl&orgparams",
            views: {
                "": {
                    templateUrl: 'login/adminLogin/adminLogin_tpl.html',
                    controller: "adminLoginCtrl"
                }
            }
        }).state('backstageLogin',{
	    	url: "/backstageLogin",
	        views: {
	            "": {
	                templateUrl: 'login/backstageLogin/backstageLogin_tpl.html',
	                controller: "backstageLoginCtrl"
	            }
	        }
	    }).state('404',{
	    	url: "/404",
	        views: {
	            "": {
	                templateUrl: 'error/404_tpl.html',
	                controller: ""
	            }
	        }
	    }).state('search', {
            url: '/search',
            views: {
                "": {
                    template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div class="view_content view_content_full mainGreen full-search-main" ui-view="main"></div>' +
                    '</div>',
                    controller: 'fullSearchModuleCtrl'
                },
                "header@search": {
                    templateUrl: 'header/header_tpl.html',
                    controller: 'headerCtrl'
                }
            }
        });
        $urlRouterProvider.otherwise("/index/homepage");
    }]);